import api from './api';
import type { PreciosProveedorImportResult } from './preciosProveedorService';

export interface PreciosArticuloImportParams {
  nombreHoja: string;
  primeraFilaDatos: number;
  /** Si se omite o es undefined, el servidor procesa hasta el final de la hoja. */
  ultimaFilaDatos?: number;
  columnaCodigoArticulo: string;
  /** Letra de columna Excel con costo base (catálogo / CPP). */
  columnaCosto: string;
  /** Opcional. Letra de columna Excel con precio neto de venta (PrecioSinIva). */
  columnaPrecioNetoVenta?: string;
  /** Opcional. Letra de columna Excel con precio mínimo neto (PrecioMinimo). */
  columnaPrecioMinimo?: string;
  dryRun: boolean;
  guardarHistorico: boolean;
}

function appendFormField(form: FormData, key: string, value: string | number | boolean): void {
  form.append(key, String(value));
}

export async function importarPreciosArticuloExcel(
  archivo: File,
  params: PreciosArticuloImportParams
): Promise<PreciosProveedorImportResult> {
  const form = new FormData();
  form.append('archivo', archivo);
  appendFormField(form, 'NombreHoja', params.nombreHoja);
  appendFormField(form, 'PrimeraFilaDatos', params.primeraFilaDatos);
  if (
    params.ultimaFilaDatos !== undefined &&
    params.ultimaFilaDatos !== null &&
    Number.isFinite(params.ultimaFilaDatos)
  ) {
    appendFormField(form, 'UltimaFilaDatos', params.ultimaFilaDatos);
  }
  appendFormField(form, 'ColumnaCodigoArticulo', params.columnaCodigoArticulo.trim());
  appendFormField(form, 'ColumnaCosto', params.columnaCosto.trim());
  const colPrecioNeto = params.columnaPrecioNetoVenta?.trim();
  if (colPrecioNeto) {
    appendFormField(form, 'ColumnaPrecioNetoVenta', colPrecioNeto);
  }
  const colPrecioMinimo = params.columnaPrecioMinimo?.trim();
  if (colPrecioMinimo) {
    appendFormField(form, 'ColumnaPrecioMinimo', colPrecioMinimo);
  }
  appendFormField(form, 'DryRun', params.dryRun);
  appendFormField(form, 'GuardarHistorico', params.guardarHistorico);

  const { data } = await api.post<PreciosProveedorImportResult>(
    '/api/PreciosProveedor/importacion-excel-por-articulo',
    form,
    {
      transformRequest: [(body, headers) => {
        delete headers['Content-Type'];
        return body as FormData;
      }],
    }
  );
  return data;
}
